module.exports = __webpack_public_path__ + "img/vip_text.d394254f.png";